var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Route, Redirect } from "react-router";
import { LangLoader } from "@irati/utils/lang";
import { NestedRoute, IndexRedirect, withPartialRoute } from "@irati/utils/history/routing";
import { HasPermissionTo } from "@irati/utils/permissions";
import authentication from "@irati/auth";
import AppContainer from "@irati/ui/src/AppContainer";
import { REWARD } from "@irati-web/app/src/routeConfig";
import RewardRouting from "@irati-web/reward/src/routes/reward";
import mainTheme from "@irati/ui/src/global/theme";
import Account from "./account";
import Polls from "../containers/Polls";
var RecognitionRoutes = /** @class */ (function (_super) {
    __extends(RecognitionRoutes, _super);
    function RecognitionRoutes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecognitionRoutes.prototype.render = function () {
        var _a = this.props, path = _a.path, location = _a.location;
        var basePathPolls = path + "/polls";
        var basePathReward = path + "/reward";
        var isRewardDisabled = authentication.apps("recognition.recognition.rewardDisabled");
        var canReward = authentication.apps("recognition.rewards.create");
        var isRecognitionAccount = location.pathname.includes("/recognition/account");
        return (React.createElement(LangLoader, { bucket: REWARD },
            React.createElement(AppContainer, { mainBackground: isRecognitionAccount && mainTheme.colors.greys.white },
                React.createElement(HasPermissionTo, { permissions: "recognition" },
                    !isRewardDisabled && canReward && React.createElement(RewardRouting, { path: basePathReward }),
                    React.createElement(NestedRoute, { match: path, path: "/account", component: Account }),
                    React.createElement(IndexRedirect, { match: { url: path }, to: "/polls" }),
                    React.createElement(NestedRoute, { useGrid: false, path: basePathPolls + "/:type(poll|recognition)?/:uuid?", title: "Recognition", component: Polls }),
                    React.createElement(Route, { path: path + "/(challenges|winners|inspire)", render: function () { return React.createElement(Redirect, { to: basePathPolls }); } })))));
    };
    return RecognitionRoutes;
}(Component));
export default withPartialRoute(RecognitionRoutes);
